module.exports = __webpack_public_path__ + "static/media/Location-red-big.9494f500.png";